import { useRouteLoaderData } from 'react-router';
import { tournamentRouteId } from './layout';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/ui/components/select';
import { useEffect, useState } from 'react';
import { API_URL } from '@/data/constants';
import { Share } from '@/components/ui/share';
import { Field, FieldLabel } from '@repo/ui/components/field';
import { BracketsRender } from '@/components/tournaments/brackets-render';

interface TournamentBracketsProps {
  readonly?: boolean;
}

export function TournamentBrackets({ readonly = false }: TournamentBracketsProps) {
  const { tournament } = useRouteLoaderData(tournamentRouteId);
  const [categoryId, setCategoryId] = useState<string | undefined>(
    tournament?.categories[0]?.id?.toString()
  );
  const [stage, setStage] = useState<'groups' | 'elimination'>(
    readonly
      ? 'groups'
      : tournament?.categories?.[0]?.status === 'groups'
      ? 'groups'
      : 'elimination'
  );

  useEffect(() => {
    if (readonly) return;
    const status = tournament?.categories?.find(
      (category: Category) => category.id === categoryId
    )?.status;
    if (status) {
      setStage(status === 'groups' ? 'groups' : 'elimination');
    }
  }, [categoryId, readonly, tournament]);

  const shareObject = {
    title: 'Inscribite al torneo',
    url: `${API_URL}/og/torneo/${tournament.id}`,
  };

  const category = tournament?.categories?.find((category: Category) => category.id === categoryId);

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="flex flex-col md:flex-row items-center md:items-end justify-between gap-4">
        <div className="flex gap-4">
          <Field>
            <FieldLabel>Categoría</FieldLabel>
            <Select
              defaultValue={tournament?.categories?.[0]?.id?.toString()}
              onValueChange={(value) => {
                setCategoryId(value);
              }}
              value={categoryId}
            >
              <SelectTrigger className="min-w-40">
                <SelectValue placeholder="Selecciona una categoría" />
              </SelectTrigger>
              <SelectContent>
                {tournament?.categories?.map((category: Category) => (
                  <SelectItem key={category.id} value={category.id.toString()}>
                    {category.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </Field>
          <Field>
            <FieldLabel>Etapa</FieldLabel>
            <Select
              defaultValue={stage}
              onValueChange={(value) => {
                setStage(value as 'groups' | 'elimination');
              }}
              value={stage}
            >
              <SelectTrigger className="min-w-40">
                <SelectValue placeholder="Selecciona una etapa" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="groups">Grupos</SelectItem>
                <SelectItem value="elimination">Eliminación directa</SelectItem>
              </SelectContent>
            </Select>
          </Field>
        </div>
        <div className="flex gap-2">
          <Share data={shareObject} title="Compartir pagina de horarios">
            Compartir pagina de horarios
          </Share>
        </div>
      </div>
      <div
        className={`flex-1 flex flex-col space-y-4 ${readonly ? '' : 'min-w-0 overflow-hidden'}`}
      >
        {readonly ? (
          <BracketsRender
            readonly
            data={stage === 'groups' ? category?.groupStage : category?.eliminationStage}
            categoryId={categoryId ?? ''}
            tournament={tournament}
            club={tournament.club}
          />
        ) : (
          <div className="flex-1 overflow-x-auto overflow-y-auto min-w-0">
            <BracketsRender
              data={stage === 'groups' ? category?.groupStage : category?.eliminationStage}
              categoryId={categoryId ?? ''}
              tournament={tournament}
              club={tournament.club}
            />
          </div>
        )}
      </div>
    </div>
  );
}
